import { render, staticRenderFns } from "./accountsReceiveTotal.vue?vue&type=template&id=a6fc74e0&scoped=true&"
import script from "./accountsReceiveTotal.vue?vue&type=script&lang=js&"
export * from "./accountsReceiveTotal.vue?vue&type=script&lang=js&"
import style0 from "./accountsReceiveTotal.vue?vue&type=style&index=0&id=a6fc74e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fc74e0",
  null
  
)

export default component.exports